<template>
  <MaskLayer>
    <Slider class="w-25" @close="close">
      <div class="p-4 h-100 overflow-auto">
        <div class="m-auto d-flex flex-column">
          <div class="m-auto d-inline-block position-relative">
            <div class="image-panel image-panel-5 rounded rounded-circle">
              <template>
                <img v-if="user.userAvatar" :src="user.userAvatar" @error="onAvatarError">
                <img v-else src="@/assets/images/default-avatar.png">
              </template>
            </div>
          </div>
          <h6 class="font-size-md">
            {{ user.userName }}
            <template v-if="user.account">
              <span v-if="user.status === 0" class="material-icons font-size-xs text-gray500 mr-1">lens</span>
              <span v-else class="material-icons font-size-xs text-success mr-1">lens</span>
            </template>
          </h6>
          <p class="font-size-md">
            {{ user.account }}
          </p>
          <h6 class="font-size-md">
            E-mail
          </h6>
          <p class="font-size-md">
            {{ user.email }}
          </p>
          <h6 class="font-size-md">
            {{ $t('auth.userSetting.form.mobile') }}
          </h6>
          <p class="font-size-md">
            {{ user.userMobile }}
          </p>
          <h6 class="font-size-md">
            {{ $t('auth.roleList') }}
          </h6>
          <p class="font-size-md">
            {{ user.roles && user.roles[0] ? `${user.roles[0].name}${user.roles[0].desc ? `(${user.roles[0].desc})` : '' }` : '' }}
          </p>
          <div class="px-2 text-primary border-left border-light">
            <template v-if="user.roles && user.roles[0] && user.roles[0].features">
              <template v-for="feature in user.roles[0].features">
                <div :key="feature.id" class="font-size-sm mb-4">
                  <h6 class="font-size-md mb-1">
                    {{ $t(`features.${feature.id}`) }}
                  </h6>
                  <ul v-if="feature.children && feature.children.length > 0" class="pl-4">
                    <template v-for="sub in feature.children">
                      <li :key="sub.id">
                        <b>{{ $t(`features.${sub.id}`) }}</b>
                      </li>
                    </template>
                  </ul>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </Slider>
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';
import Slider from '@/components/Slider.vue';
import PermissionService from '@/services/PermissionService';
import defaultAvatar from '@/assets/images/default-avatar.png';

export default {
  components: {
    MaskLayer,
    Slider,
  },
  props: {
    userId: {
      type: String
    }
  },
  data() {
    return {
      user: {}
    };
  },
  async created() {
    const vm = this;

    await vm.$loading(async () => {
      const result = await PermissionService.GetCompanyUserProfileAsync(vm.userId);
      if (result.roles && result.roles[0]) {
        // 取得第一筆角色功能資料
        result.roles[0].features = await PermissionService.GetRoleFeaturesAsync(result.roles[0].id);
      }

      vm.user = result;
    });
  },
  methods: {
    // 問題頭像處理
    onAvatarError(e) {
      e.target.src = defaultAvatar;
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
